<template>
  <div class="notification-item my-2 pa-2 elevation-2">
    <div class="notification-item__title">
      <div>
        <span class="text-subtitle-2 text--secondary d-block">{{notification.Notification_Created | createdFilter}}</span>
        <span class="text-subtitle-1">{{notification.Notification_Title}}</span>
      </div>
      <v-btn
        v-if="notification.Notification_Type_ID !== 1 && !notification.Is_Deleted"
        icon
        small
        color="red darken-2"
        @click="removeNotification"
      >
        <v-icon>mdi-delete-circle</v-icon>
      </v-btn>
    </div>
    <v-divider></v-divider>
    <div class="notification-item__message py-1 text-caption text-justify">
      {{ notificationMessageDisplay }}
      <div v-if="!showAll && requesterUnit" class="mt-1">
        Unit: {{ requesterUnit }}
      </div>
      <div v-if="showAll && displayRequestStatus" class="mt-1">
        Status: {{ displayRequestStatus }}
      </div>
      <v-divider v-if="isAboutBonus && notProcessed"></v-divider>
      <div v-if="showAttachingFileBlock" class="notification-item__message py-1 text-caption text-justify">
        Attaching file: <a v-if="attachingFile.File_Name && attachingFile.file && attachingFile.file.data" @click="openFile(attachingFile.file.data, attachingFile.File_Type)">{{ attachingFile.File_Name }}</a>
        <span v-else>{{ attachingFile.File_Name || '—' }}</span>
      </div>
      <v-text-field
        v-if="reasonField"
        dense
        hide-details
        v-model="reason"
        :placeholder="this.isRaiseRequest ? 'Question' : this.isRefundRequest && this.isRefundRequestApproved ? 'Comment' : 'Rejection Reason'"
      ></v-text-field>
      <p
        v-if="isRefundRequest && !isCEO && !isRefundTaxiType && !reasonField && notProcessed"
        class="mt-1 mb-0 text-caption text--secondary"
      >
        Requires a comment to forward to CEO.
      </p>
    </div>
    <v-divider v-if="notification.Notification_Type_ID === 1 && notProcessed"></v-divider>
    <div class="notification-item__actions mt-1" v-if="notification.Notification_Type_ID === 1 && notProcessed">
      <v-btn
        small
        outlined
        color="primary"
        v-if="reasonField"
        @click="cancelRequest"
      >
        Cancel
      </v-btn>
      <v-btn
        small
        :color="this.isRefundRequest && this.isRefundRequestApproved ? 'success' : 'red darken-2 white--text'"
        :disabled="refundSecondStepSubmitDisabled"
        @click="approveRequest(false)"
      >
        {{ this.isRaiseRequest ? 'Question or answer' : this.isRefundRequest && this.isRefundRequestApproved ? 'Approve' : 'Reject' }}
      </v-btn>
      <v-btn
        v-if="!reasonField"
        small
        color="success"
        :disabled="isRefundRequest && !refundFileByNotifLoaded"
        @click="approveRequest(true)"
      >
        Approve
      </v-btn>
    </div>
    <v-dialog v-model="showEquipmentAdditionalApprovalDialog" max-width="500" persistent>
      <v-card>
        <v-card-title class="text-h6">Additional approval</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <p>Does this request require additional approval (expensive equipment)?</p>
          <v-radio-group v-model="equipmentAdditionalApprovalChoice">
            <v-radio label="No, approve now" value="no"></v-radio>
            <v-radio label="Yes, request additional approval" value="yes"></v-radio>
          </v-radio-group>
          <v-select
            v-if="equipmentAdditionalApprovalChoice === 'yes'"
            v-model="equipmentAdditionalApproverId"
            :items="equipmentAdditionalApproversList"
            item-value="Employee_ID"
            item-text="Employee_Full_Name"
            label="Choose Additional Approver"
          ></v-select>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small text @click="cancelEquipmentAdditionalApproval">Cancel</v-btn>
          <v-btn
            small
            color="success"
            :disabled="!equipmentAdditionalApprovalChoice || (equipmentAdditionalApprovalChoice === 'yes' && !equipmentAdditionalApproverId)"
            @click="confirmEquipmentApproval"
          >Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { getApiErrorMessage } from '@/utils/apiError'
import { formatLocalDate } from '@/utils/dateUtils'
export default {
  props: {
    notification: {
      required: true
    },
    showAll: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  name: 'NotificationItem',
  data () {
    return {
      expert_estimation: null,
      reasonField: false,
      reason: null,
      attachingFile: {
        file: {},
        File_Name: '',
        File_Type: ''
      },
      isRefundRequestApproved: false,
      refundRequestRefundTypeId: null,
      refundRequestRefundTypeName: '',
      refundFileByNotifLoaded: true,
      CEO_ID: 2,
      showEquipmentAdditionalApprovalDialog: false,
      equipmentAdditionalApprovalChoice: null,
      equipmentAdditionalApproverId: null,
      equipmentAdditionalApproversList: [
        { Employee_ID: 2, Employee_Full_Name: 'Dima Semensky – CEO' },
        { Employee_ID: 13, Employee_Full_Name: 'Vitaliy Matvisiv – Director of Tech Support Department' }
      ],
      pendingEquipmentApproveNotificationId: null
    }
  },
  mounted () {
    if (this.isAboutBonus) {
      this.getBonusFileByNotificationId(this.notification.Notification_ID)
    } else if (this.isRefundRequest) {
      this.refundFileByNotifLoaded = false
      this.getRefundFileByNotificationId(this.notification.Notification_ID)
    } else if (this.isEquipmentReplacementRequest) {
      const requestId = this.equipmentReplacementRequestIdFromMessage
      if (requestId != null) {
        this.getEquipmentReplacementFileByRequestId(requestId)
      } else {
        this.getEquipmentReplacementFileByNotificationId(this.notification.Notification_ID)
      }
    } else if (this.isSickLeaveRequest) {
      this.getAbsenceFileByNotificationId(this.notification.Notification_ID)
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    isAboutBonus () {
      return this.notification.Notification_Title.toLowerCase().includes('bonus request')
    },
    isRaiseRequest () {
      return this.notification.Notification_Title.toLowerCase().includes('request for raise')
    },
    isRefundRequest () {
      return this.notification.Notification_Title.toLowerCase().includes('refund')
    },
    isSickLeaveRequest () {
      return this.notification.Notification_Title.toLowerCase().includes('sick leave')
    },
    isEquipmentReplacementRequest () {
      const t = this.notification.Notification_Title.toLowerCase()
      return t.includes('equipment replacement') || t.includes('eq. replacement') || t.includes('equipment update')
    },
    equipmentReplacementRequestIdFromMessage () {
      const msg = this.notification.Notification_Message || ''
      const m = msg.match(/\[Request_ID:\s*(\d+)\]/)
      return m ? parseInt(m[1], 10) : null
    },
    isCEO () {
      return this.user.employee_id === this.CEO_ID
    },
    isRefundTaxiType () {
      const n = (this.refundRequestRefundTypeName || '').toLowerCase()
      return n.includes('taxi')
    },
    refundSecondStepSubmitDisabled () {
      if (!this.reasonField) return false
      if (this.isRefundRequest && this.isRefundRequestApproved && this.isRefundTaxiType) return false
      return !this.reason
    },
    showAttachingFileBlock () {
      if (!(this.isAboutBonus || this.isRefundRequest || this.isEquipmentReplacementRequest || this.isSickLeaveRequest) || !this.notProcessed) return false
      if ((this.isEquipmentReplacementRequest || this.isSickLeaveRequest) && !this.attachingFile.File_Name) return false
      return true
    },
    notificationMessageDisplay () {
      const msg = this.notification.Notification_Message || ''
      return msg
        .replace(/\s*\[Request_ID:\s*\d+\]\s*$/, '')
        .replace(/^\s+/gm, '')
        .trim()
    },
    isRequestRelatedNotification () {
      const title = (this.notification.Notification_Title || '').toLowerCase()
      const msg = (this.notification.Notification_Message || '').toLowerCase()
      return Number(this.notification.Notification_Type_ID) === 1 ||
        title.includes('request') ||
        title.includes('refund') ||
        title.includes('bonus') ||
        title.includes('l&d') ||
        title.includes('equipment') ||
        title.includes('absence') ||
        title.includes('raise') ||
        title.includes('sick') ||
        title.includes('eq. replacement') ||
        msg.includes('request')
    },
    requesterUnit () {
      if (this.showAll || !this.isRequestRelatedNotification) return ''
      return String(this.notification.Employee_From_Department || '').trim()
    },
    displayRequestStatus () {
      if (!this.showAll || !this.isRequestRelatedNotification) return null
      if (this.notification.Request_Status) return this.notification.Request_Status

      const title = (this.notification.Notification_Title || '').toLowerCase()
      const msg = (this.notification.Notification_Message || '').toLowerCase()
      if (title.includes('rejected')) return 'Rejected'
      if (title.includes('approved by ceo')) return 'Approved'
      if (title.includes('approved by am') || msg.includes('pending ceo')) return 'Pending'
      if (title.includes('pending additional') || msg.includes('additional approval')) return 'Pending'
      if (title.includes('approved')) return 'Approved'
      if (Number(this.notification.Notification_Type_ID) === 1) return 'Pending'
      return null
    },
    notProcessed () {
      if (this.showAll) {
        const deleted = this.notification.Is_Deleted
        if (deleted === true || deleted === 1 || deleted === '1' || deleted === 'true') return false
        if (this.notification.Approved_Absence_Request !== null && this.notification.Approved_Absence_Request !== undefined) return false
        if (this.notification.Approved_Bonus_Request !== null && this.notification.Approved_Bonus_Request !== undefined) return false
        if (this.notification.Approved_L_And_D_Request !== null && this.notification.Approved_L_And_D_Request !== undefined) return false
        if (this.notification.Approved_Refund_Request !== null && this.notification.Approved_Refund_Request !== undefined) return false
        if (this.notification.Approved_Equipment_Replacement_Request !== null && this.notification.Approved_Equipment_Replacement_Request !== undefined) return false
        return true
      }
      return true
    }
  },
  filters: {
    createdFilter (val) {
      return val.substring(0, 10)
    }
  },
  methods: {
    removeNotification () {
      this.axios.delete(`/api/notifications/${this.notification.Notification_ID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$emit('updated')
        this.$store.dispatch('setSuccess', { successMsg: 'Notification removed' })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    updateAbsenceRequest (notificationID, approve) {
      this.axios.put('/api/requests/absence', {
        Notification_ID: notificationID,
        Approved: approve,
        Rejection_Reason: this.reason
      },
      {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$emit('updated')
        this.reason = null
        this.$store.dispatch('setSuccess', { successMsg: `Request ${approve ? 'approved' : 'rejected'}` })
        this.sendEmailAboutAbsenceRequest(notificationID)
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    updateLAndDRequest (notificationID, approve) {
      this.axios.put('/api/requests/l_and_d', {
        Notification_ID: notificationID,
        AM_Approved: approve,
        Rejection_Reason: this.reason
      },
      {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$emit('updated')
        this.reason = null
        this.$store.dispatch('setSuccess', { successMsg: `Request ${approve ? 'approved' : 'rejected'}` })
        this.sendEmailAboutLAndDRequest(notificationID)
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    updateRefundRequest (notificationID, approve) {
      this.axios.put('/api/requests/refund', {
        Notification_ID: notificationID,
        Approved: approve,
        Rejection_Reason: this.reason
      },
      {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then((res) => {
        this.$emit('updated')
        this.reason = null
        this.$store.dispatch('setSuccess', { successMsg: `Request ${approve ? 'approved' : 'rejected'}` })
        this.sendEmailAboutRefundRequest(res.data[0].Request_ID)
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    updateEquipmentReplacementRequest (notificationID, approve) {
      const isAdditionalApproval = this.notification.Notification_Title.toLowerCase().includes('add. approval')
      if (approve && !isAdditionalApproval) return
      this.axios.put('/api/requests/equipment_replacement_by_notification', {
        Notification_ID: notificationID,
        Approved: approve,
        Rejection_Reason: approve ? null : this.reason,
        Confirmer_ID: this.user.employee_id
      }, {
        headers: { Authorization: 'Bearer ' + this.user.token }
      }).then((res) => {
        this.$emit('updated')
        this.reason = null
        this.$store.dispatch('setSuccess', { successMsg: approve ? 'Request approved' : 'Request rejected' })
        if (res.data && res.data[0] && res.data[0].Request_ID) {
          this.sendEmailAboutEquipmentReplacementRequest(res.data[0].Request_ID)
        }
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    updateBonusRequest (notificationID, approve) {
      this.axios.put('/api/requests/bonus', {
        Notification_ID: notificationID,
        Approved: approve,
        Rejection_Reason: this.reason
      },
      {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$emit('updated')
        this.reason = null
        this.$store.dispatch('setSuccess', { successMsg: `Request ${approve ? 'approved' : 'rejected'}` })
        this.sendEmailAboutBonusRequestApproving(res.data[0].Request_ID, approve)
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    updateRaiseRequest (notificationID, approve) {
      this.axios.put('/api/requests/raise', {
        Notification_ID: notificationID,
        Approved: approve,
        Date_Of_Update: formatLocalDate(new Date()),
        Reason: this.reason,
        Approved_ID: this.user.employee_id
      },
      {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$emit('updated')
        this.sendEmailOnRaiseRequestUpdate(this.notification)
        this.reason = null
        this.$store.dispatch('setSuccess', { successMsg: `Request ${approve ? 'approved' : 'updated'}` })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    linkToFile (data, type) {
      let res = ''
      let binary = ''
      const bytes = new Uint8Array(data)
      const len = bytes.byteLength
      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i])
      }
      res = `data:${type};base64, ${window.btoa(binary)}`
      return res
    },
    openFile (data, type) {
      var win = window.open()
      if (!win) {
        this.$store.dispatch('setError', { errorMsg: 'Please allow popups' })
        return
      }
      win.document.write('<iframe src="' + this.linkToFile(data, type) + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>')
    },
    approveRequest (approve) {
      const refundSecondStepConfirm =
        this.isRefundRequest && this.isRefundRequestApproved && this.isRefundTaxiType && !approve
      if (approve || (!approve && this.reason) || refundSecondStepConfirm) {
        if (this.isRefundRequest && approve && !this.isRefundRequestApproved && !this.isCEO && !this.isRefundTaxiType) {
          this.isRefundRequestApproved = true
          this.reasonField = !this.reasonField
          return
        }
        if (approve && this.isEquipmentReplacementRequest && !this.notification.Notification_Title.toLowerCase().includes('add. approval')) {
          this.pendingEquipmentApproveNotificationId = this.notification.Notification_ID
          this.equipmentAdditionalApprovalChoice = null
          this.equipmentAdditionalApproverId = null
          this.showEquipmentAdditionalApprovalDialog = true
          return
        }
        this.axios.delete(`/api/notifications/${this.notification.Notification_ID}`, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(deleteRes => {
          const res = deleteRes.data[0]
          if (res && !(this.notification.Notification_Title.toLowerCase().includes('bonus request') || this.notification.Notification_Title.toLowerCase() === 'request for raise')) {
            const from = res.Notification_Employee_ID_From
            const to = res.Notification_Employee_ID_To
            const title = res.Notification_Title
            res.Notification_Employee_ID_From = to
            res.Notification_Employee_ID_To = from
            res.Notification_Type_ID = 2
            res.Notification_Created = new Date().toISOString()
            res.Notification_Title = `Request ${approve ? 'approved' : 'rejected'}`
            if (this.notification.Notification_Title.toLowerCase().includes('l&d') && approve) {
              res.Notification_Message = `Your ${title.toLowerCase()} ${approve ? 'approved' : 'rejected'}, please find your request in history and upload payment files (after that financier can approve it)`
            } else if (this.isRefundRequest && this.isRefundRequestApproved && !this.isCEO && !this.isRefundTaxiType) {
              res.Notification_Title = 'Request approved by AM'
              res.Notification_Message = `Your ${title.toLowerCase()} approved by AM, pending CEO approval`
            } else if (this.isRefundRequest && this.isRefundRequestApproved && this.isCEO) {
              res.Notification_Title = 'Request approved by CEO'
              res.Notification_Message = `Your ${title.toLowerCase()} approved by CEO`
            } else {
              res.Notification_Message = `Your ${title.toLowerCase()} ${approve ? 'approved' : 'rejected'}`
              if (!approve) {
                res.Notification_Message += `\nReason: ${this.reason}`
              }
            }
            this.axios.post('/api/notifications', res, {
              headers: {
                Authorization: 'Bearer ' + this.user.token
              }
            }).then(() => {
              if (this.notification.Notification_Title.toLowerCase().includes('l&d')) {
                this.updateLAndDRequest(this.notification.Notification_ID, approve)
              } else if (this.notification.Notification_Title.toLowerCase().includes('refund')) {
                if (this.isRefundRequestApproved && !this.isCEO && !this.isRefundTaxiType) {
                  this.notification.Notification_Message = `Approved by AM, comment: ${this.reason}`
                  this.createCEORefundNotification()
                } else {
                  const refundApproved =
                    refundSecondStepConfirm ? true : (this.isRefundRequestApproved ? true : approve)
                  this.updateRefundRequest(this.notification.Notification_ID, refundApproved)
                }
              } else if (this.isEquipmentReplacementRequest) {
                this.updateEquipmentReplacementRequest(this.notification.Notification_ID, approve)
              } else {
                this.updateAbsenceRequest(this.notification.Notification_ID, approve)
              }
            }).catch(error => {
              const errorMsg = getApiErrorMessage(error)
              this.$store.dispatch('setError', { errorMsg })
            })
          } else if (this.notification.Notification_Title.toLowerCase().includes('bonus request')) {
            this.updateBonusRequest(this.notification.Notification_ID, approve)
          } else if (this.notification.Notification_Title.toLowerCase() === 'request for raise') {
            this.updateRaiseRequest(this.notification.Notification_ID, approve)
          }
        }).catch(error => {
          const errorMsg = getApiErrorMessage(error)
          this.$store.dispatch('setError', { errorMsg })
        })
      }
      if (!approve) {
        this.reasonField = !this.reasonField
      }
    },
    getBonusFileByNotificationId (notificationId) {
      this.axios.get(`/api/requests/bonus_file_by_notif/${notificationId}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        try {
          if (res && res.data) {
            const responseData = res.data[0]
            if (responseData) {
              this.attachingFile.File_Name = (responseData.Confirmation_File_Name !== undefined && responseData.Confirmation_File_Name !== null) ? String(responseData.Confirmation_File_Name) : ''
              this.attachingFile.File_Type = (responseData.Confirmation_File_Type !== undefined && responseData.Confirmation_File_Type !== null) ? String(responseData.Confirmation_File_Type) : ''

              if (responseData.File && responseData.File.data) {
                this.attachingFile.file = responseData.File
              } else {
                this.attachingFile.file = { data: [] }
              }
            } else {
              this.attachingFile.File_Name = ''
              this.attachingFile.File_Type = ''
              this.attachingFile.file = { data: [] }
            }
          } else {
            this.attachingFile.File_Name = ''
            this.attachingFile.File_Type = ''
            this.attachingFile.file = { data: [] }
          }
        } catch (e) {
          console.error('Error processing bonus file data:', e)
          this.attachingFile.File_Name = ''
          this.attachingFile.File_Type = ''
          this.attachingFile.file = { data: [] }
        }
      }).catch(error => {
        this.attachingFile.File_Name = ''
        this.attachingFile.File_Type = ''
        this.attachingFile.file = { data: [] }
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    getAbsenceFileByNotificationId (notificationId) {
      this.axios.get(`/api/requests/absence_file_by_notif/${notificationId}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        try {
          if (res && res.data) {
            const fileData = res.data[0]
            if (fileData) {
              this.attachingFile.File_Name = (fileData.Confirmation_File_Name !== undefined && fileData.Confirmation_File_Name !== null) ? String(fileData.Confirmation_File_Name) : ''
              this.attachingFile.File_Type = (fileData.Confirmation_File_Type !== undefined && fileData.Confirmation_File_Type !== null) ? String(fileData.Confirmation_File_Type) : ''
              this.attachingFile.file = fileData.Confirmation_File && fileData.Confirmation_File.data ? fileData.Confirmation_File : { data: [] }
            } else {
              this.attachingFile.File_Name = ''
              this.attachingFile.File_Type = ''
              this.attachingFile.file = { data: [] }
            }
          } else {
            this.attachingFile.File_Name = ''
            this.attachingFile.File_Type = ''
            this.attachingFile.file = { data: [] }
          }
        } catch (e) {
          console.error('Error processing absence file data:', e)
          this.attachingFile.File_Name = ''
          this.attachingFile.File_Type = ''
          this.attachingFile.file = { data: [] }
        }
      }).catch(error => {
        this.attachingFile.File_Name = ''
        this.attachingFile.File_Type = ''
        this.attachingFile.file = { data: [] }
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    getRefundFileByNotificationId (notificationId) {
      this.axios.get(`/api/requests/refund_file_by_notif/${notificationId}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        try {
          if (res && res.data) {
            const fileData = res.data[0]
            if (fileData) {
              this.attachingFile.File_Name = (fileData.Confirmation_File_Name !== undefined && fileData.Confirmation_File_Name !== null) ? String(fileData.Confirmation_File_Name) : ''
              this.attachingFile.File_Type = (fileData.Confirmation_File_Type !== undefined && fileData.Confirmation_File_Type !== null) ? String(fileData.Confirmation_File_Type) : ''
              this.attachingFile.file = fileData.Confirmation_File || null
              this.refundRequestRefundTypeId = fileData.Refund_Type_ID != null ? fileData.Refund_Type_ID : null
              this.refundRequestRefundTypeName = fileData.Refund_Type_Name != null ? String(fileData.Refund_Type_Name) : ''
            } else {
              this.attachingFile.File_Name = ''
              this.attachingFile.File_Type = ''
              this.attachingFile.file = null
              this.refundRequestRefundTypeId = null
              this.refundRequestRefundTypeName = ''
            }
          } else {
            this.attachingFile.File_Name = ''
            this.attachingFile.File_Type = ''
            this.attachingFile.file = null
            this.refundRequestRefundTypeId = null
            this.refundRequestRefundTypeName = ''
          }
        } catch (e) {
          console.error('Error processing refund file data:', e)
          this.attachingFile.File_Name = ''
          this.attachingFile.File_Type = ''
          this.attachingFile.file = null
          this.refundRequestRefundTypeId = null
          this.refundRequestRefundTypeName = ''
        }
      }).catch(error => {
        this.attachingFile.File_Name = ''
        this.attachingFile.File_Type = ''
        this.attachingFile.file = null
        this.refundRequestRefundTypeId = null
        this.refundRequestRefundTypeName = ''
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      }).finally(() => {
        this.refundFileByNotifLoaded = true
      })
    },
    getEquipmentReplacementFileByNotificationId (notificationId) {
      this._setEquipmentReplacementFileFromResponse(
        this.axios.get(`/api/requests/equipment_replacement_file_by_notif/${notificationId}`, {
          headers: { Authorization: 'Bearer ' + this.user.token }
        })
      )
    },
    getEquipmentReplacementFileByRequestId (requestId) {
      this._setEquipmentReplacementFileFromResponse(
        this.axios.get(`/api/requests/equipment_replacement_file_by_request_id/${requestId}`, {
          headers: { Authorization: 'Bearer ' + this.user.token }
        })
      )
    },
    _setEquipmentReplacementFileFromResponse (promise) {
      promise.then(res => {
        try {
          if (res && res.data) {
            const fileData = res.data[0]
            if (fileData) {
              this.attachingFile.File_Name = (fileData.Confirmation_File_Name !== undefined && fileData.Confirmation_File_Name !== null) ? String(fileData.Confirmation_File_Name) : ''
              this.attachingFile.File_Type = (fileData.Confirmation_File_Type !== undefined && fileData.Confirmation_File_Type !== null) ? String(fileData.Confirmation_File_Type) : ''
              this.attachingFile.file = fileData.Confirmation_File && fileData.Confirmation_File.data ? fileData.Confirmation_File : { data: [] }
            } else {
              this.attachingFile.File_Name = ''
              this.attachingFile.File_Type = ''
              this.attachingFile.file = { data: [] }
            }
          } else {
            this.attachingFile.File_Name = ''
            this.attachingFile.File_Type = ''
            this.attachingFile.file = { data: [] }
          }
        } catch (e) {
          this.attachingFile.File_Name = ''
          this.attachingFile.File_Type = ''
          this.attachingFile.file = { data: [] }
        }
      }).catch(() => {
        this.attachingFile.File_Name = ''
        this.attachingFile.File_Type = ''
        this.attachingFile.file = { data: [] }
      })
    },
    sendEmailOnRaiseRequestUpdate (notifdata) {
      const body = {
        employeeIDs: notifdata.Notification_Employee_ID_To,
        notificationData: notifdata
      }
      this.axios.post('/api/emails/sendemailforraiserequestupdate', body, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setSuccess', { successMsg: 'Email sent' })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    sendEmailAboutBonusRequestApproving (requestId, approve) {
      this.axios.post('/api/emails/sendemailforbonusapprove', {
        Request_ID: requestId,
        Approved: approve
      }, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setSuccess', { successMsg: 'Email sent' })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    sendEmailAboutAbsenceRequest (notificationID) {
      this.axios.post('/api/emails/sendemailforabsencerequest', {
        Notification_ID: notificationID
      }, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setSuccess', { successMsg: 'Email sent' })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    sendEmailAboutRefundRequest (requestID) {
      this.axios.post('/api/emails/sendemailforrefundrequest', {
        Request_ID: requestID
      }, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(() => {
        this.$store.dispatch('setSuccess', { successMsg: 'Email sent' })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    sendEmailAboutEquipmentReplacementRequest (requestID) {
      this.axios.post('/api/emails/sendemailaboutequipmentreplacementrequest', {
        Request_ID: requestID
      }, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(() => {
        this.$store.dispatch('setSuccess', { successMsg: 'Email sent' })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    sendEmailAboutLAndDRequest (notificationID) {
      this.axios.post('/api/emails/sendemailforlanddevrequest', {
        Notification_ID: notificationID
      }, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setSuccess', { successMsg: 'Email sent' })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    cancelEquipmentAdditionalApproval () {
      this.showEquipmentAdditionalApprovalDialog = false
      this.pendingEquipmentApproveNotificationId = null
      this.equipmentAdditionalApprovalChoice = null
      this.equipmentAdditionalApproverId = null
    },
    async confirmEquipmentApproval () {
      const notificationID = this.pendingEquipmentApproveNotificationId
      const headers = { Authorization: 'Bearer ' + this.user.token }

      if (this.equipmentAdditionalApprovalChoice === 'no') {
        try {
          await this.axios.delete(`/api/notifications/${notificationID}`, { headers })
          const res = await this.axios.put('/api/requests/equipment_replacement_by_notification', {
            Notification_ID: notificationID,
            Approved: true,
            Rejection_Reason: null,
            Confirmer_ID: this.user.employee_id
          }, { headers })
          this.$emit('updated')
          this.showEquipmentAdditionalApprovalDialog = false
          this.$store.dispatch('setSuccess', { successMsg: 'Request approved' })
          if (res.data && res.data[0] && res.data[0].Request_ID) {
            this.sendEmailAboutEquipmentReplacementRequest(res.data[0].Request_ID)
          }
        } catch (error) {
          const errorMsg = getApiErrorMessage(error)
          this.$store.dispatch('setError', { errorMsg })
        }
      } else {
        try {
          const requesterName = this.notification.Notification_Title.replace(/^Equipment (update|replacement) request from /i, '')
          const additionalNotif = {
            Notification_Type_ID: 1,
            Notification_Title: `Equipment update (add. approval) from ${requesterName}`,
            Notification_Message: this.notification.Notification_Message,
            Notification_Created: new Date().toISOString(),
            Notification_Employee_ID_From: this.user.employee_id,
            Notification_Employee_ID_To: this.equipmentAdditionalApproverId
          }
          const notifRes = await this.axios.post('/api/notifications', additionalNotif, { headers })
          const additionalNotifId = notifRes.data[0].Notification_ID

          await this.axios.delete(`/api/notifications/${notificationID}`, { headers })
          const res = await this.axios.put('/api/requests/equipment_replacement_by_notification', {
            Notification_ID: notificationID,
            Approved: true,
            Rejection_Reason: null,
            Confirmer_ID: this.user.employee_id,
            Request_Additional_Approval: true,
            Additional_Confirmer_ID: this.equipmentAdditionalApproverId,
            Additional_Notification_ID: additionalNotifId
          }, { headers })

          const requestId = res.data && res.data[0] && res.data[0].Request_ID
          if (requestId) {
            this.sendEmailAboutEquipmentReplacementRequest(requestId)
          }

          this.$emit('updated')
          this.showEquipmentAdditionalApprovalDialog = false
          this.$store.dispatch('setSuccess', { successMsg: 'Request approved, pending additional approval' })
        } catch (error) {
          const errorMsg = getApiErrorMessage(error)
          this.$store.dispatch('setError', { errorMsg })
        }
      }
      this.pendingEquipmentApproveNotificationId = null
      this.equipmentAdditionalApprovalChoice = null
      this.equipmentAdditionalApproverId = null
    },
    cancelRequest () {
      if (this.isRefundRequest) {
        this.isRefundRequestApproved = false
      }
      this.reasonField = false
      this.reason = null
    },
    createCEORefundNotification () {
      const notificationData = {
        Notification_Message: this.notification.Notification_Message,
        Notification_Title: this.notification.Notification_Title,
        Notification_Created: new Date().toISOString(),
        Notification_Employee_ID_From: this.notification.Notification_Employee_ID_From,
        Notification_Employee_ID_To: this.CEO_ID,
        Notification_Type_ID: 1
      }

      const headers = {
        Authorization: 'Bearer ' + this.user.token
      }

      const oldNotificationId = this.notification.Notification_ID

      this.axios.post('/api/notifications', notificationData, { headers })
        .then((response) => {
          const newNotificationId = response.data[0].Notification_ID
          return this.axios.put(`/api/requests/update_notification_refund_request_by_old/${oldNotificationId}`, {
            New_Notification_ID: newNotificationId
          }, { headers })
        })
        .then(() => {
          this.$emit('updated')
          this.reason = null
          this.$store.dispatch('setSuccess', { successMsg: 'Refund request forwarded to CEO for final approval' })
        })
        .catch(error => {
          const errorMsg = getApiErrorMessage(error)
          this.$store.dispatch('setError', { errorMsg })
        })
    }
  }
}
</script>
<style lang="scss">
  .notification-item {
    &__actions, &__title {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    &__title {
      align-items: flex-start;
    }
    &__message {
      white-space: pre-wrap;
    }
  }
</style>
